import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [favorites, setFavorites] = useState([]);

  const loadFavorites = useCallback(async () => {
    try {
      const r = await api.get("/my/favorites");
      setFavorites(r.data.map((p) => p.sku));
    } catch { setFavorites([]); }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("suhool_token");
    if (!token) { setReady(true); return; }
    api.get("/auth/me").then((r) => { setUser(r.data); loadFavorites(); })
      .catch(() => localStorage.removeItem("suhool_token"))
      .finally(() => setReady(true));
  }, [loadFavorites]);

  const persist = (data) => {
    localStorage.setItem("suhool_token", data.access_token);
    setUser(data.user);
    loadFavorites();
  };

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    persist(r.data);
    return r.data.user;
  };

  const register = async (name, email, password) => {
    const r = await api.post("/auth/register", { name, email, password });
    persist(r.data);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("suhool_token");
    setUser(null);
    setFavorites([]);
  };

  const toggleFavorite = async (sku) => {
    if (!user) return false;
    const r = await api.post(`/my/favorites/${sku}`);
    setFavorites(r.data.favorites);
    if (r.data.active) toast.success("أُضيف إلى المفضلة");
    else toast("أُزيل من المفضلة");
    return r.data.active;
  };

  const isFavorite = (sku) => favorites.includes(sku);

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, favorites, toggleFavorite, isFavorite, reloadFavorites: loadFavorites }}>
      {children}
    </AuthContext.Provider>
  );
}
